import { queryOptions } from '@tanstack/react-query';
import { statusKeys } from '@shared/api/query-keys';
import { statusApi } from './status';

/**
 * Co-located `queryOptions` for the status domain (Server-state rebuild, P2). Key + queryFn
 * defined once; hooks add per-call overrides (`enabled`).
 */
export const statusQueries = {
  overview: (auditId?: string) =>
    queryOptions({
      queryKey: statusKeys.overview(auditId),
      queryFn: () => statusApi.getAll(auditId as string),
    }),
  tasks: (auditId?: string) =>
    queryOptions({
      queryKey: statusKeys.tasks(auditId),
      queryFn: () => statusApi.getTasks(auditId as string),
    }),
};
